import { createTheme } from '@mui/material';

const commonOverrides = {
  typography: {
    h4: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    }
  },
};

const lightPalette = {
  mode: 'light',
  primary: {
    main: '#1a73e8',
    light: '#63a4ff',
    dark: '#1558b0',
    contrastText: '#ffffff'
  },
  secondary: {
    main: '#dce8ff',
    light: '#f0f5ff',
    dark: '#a2bce6',
    contrastText: '#0b1220'
  },
  background: {
    default: '#f5f7fb',
    paper: '#ffffff'
  },
  warning: {
    main: '#e0a152',
    dark: '#b4792c',
    light: '#f5c278',
    contrastText: '#0b1220'
  },
  text: {
    primary: '#0b1220',
    secondary: '#2f3b52'
  }
};

const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#d6b25e',
    light: '#f1e3b0',
    dark: '#9e7b2a',
    contrastText: '#0b1220'
  },
  secondary: {
    main: '#0f1f38',
    light: '#1f3250',
    dark: '#0a1426',
    contrastText: '#eae4d3'
  },
  background: {
    default: '#0b1220',
    paper: '#131c2c'
  },
  warning: {
    main: '#e0a152',
    dark: '#b4792c',
    light: '#f0c483',
    contrastText: '#0b1220'
  }
};

export const createAppTheme = (mode = 'dark') => createTheme({
  palette: mode === 'light' ? lightPalette : darkPalette,
  ...commonOverrides,
});
